module.exports = __webpack_public_path__ + "static/media/14_l_holst_two_14.38_92.78.2310c637.png";